import React from 'react';
import { IconType } from 'react-icons';
import { IconBaseProps } from 'react-icons/lib';

interface IconWrapperProps {
  icon: IconType;
  size?: number;
  className?: string;
  onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
}

const IconWrapper: React.FC<IconWrapperProps> = ({ icon: Icon, size, className, onClick }) => {
  return (
    <div onClick={onClick} style={{ display: 'inline-flex', cursor: onClick ? 'pointer' : 'inherit' }}>
      {React.createElement(Icon as React.ComponentType<IconBaseProps>, { size, className })}
    </div>
  );
};

export default IconWrapper; 